export default __webpack_public_path__ + "static/media/microbreaks.3e91cc31.svg";